namespace Ir.Components.Workbook.ToolBar.EditingButtonsToolBar {
    interface IViewModel {
        editModeOptions: DevExpress.ui.dxButton.Properties,
        saveOptions: DevExpress.ui.dxButton.Properties,
        undoOptions: DevExpress.ui.dxButton.Properties,
    }

    export function getViewModel(this: IViewModel, params: any) {
        this.editModeOptions = {
            stylingMode: 'text',
            width: 26,
            height: 26,
            template: ko.computed(function () {
                return `<i class="ms">${(workbook.workbookConfig.generalSettings.editing() ? "edit_square" : workbook.workbookConfig.userEditMode === WorkbookEditModeEnum.Restricted ? "visibility_lock" : "visibility")}</i>`
            }) as any,
            hint: ko.computed(function () {
                return `${(workbook.workbookConfig.generalSettings.editing() ? "Edit" : "View")} Mode`;
            }) as any,
            onClick() {
                workbook.workbookConfig.generalSettings.editing(!workbook.workbookConfig.generalSettings.editing());
                workbook.workbookConfig.generalSettings.onEditingChanged();
            },
            disabled: ko.computed(function () {
                return !(loggedUser.permissions.workbooks() || (workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.ViewOnly && workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted));
            }) as any
        };

        this.saveOptions = {
            stylingMode: 'text',
            hint: 'Save changes to Workbook',
            width: 26,
            height: 26,
            template: `<i class="ms">save</i>`,
            onClick(e) {
                workbook.workbookConfig.workbookHelper.save();
            },
            visible: ko.computed(function () {
                return workbook.workbookConfig.generalSettings.editing() && (loggedUser.permissions.workbooks() || workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted);
            }) as any
        };

        this.undoOptions = {
            stylingMode: 'text',
            hint: 'Undo Changes',
            width: 26,
            height: 26,
            template: `<i class="ms">undo</i>`,
            onClick(e) {
                document.location = `${urlConfigs.tabs}UndoChanges/${workbook.workbookConfig.workbookId()}`;
            },
            disabled: ko.computed(function () { return workbook.workbookConfig.workbookId() < 0; }) as any,
        };
    }
}